import LaurelLogo from '@/components/LaurelLogo';
import { cn } from '@/lib/utils';

interface LogoProps extends React.SVGProps<SVGSVGElement> {
  /** 'dark' = brand charcoal wordmark (for cream/light backgrounds)
   *  'light' = white wordmark (for forest green backgrounds) */
  variant?: 'dark' | 'light';
}

const Logo = ({ variant = 'dark', className = '', ...props }: LogoProps) => (
  <LaurelLogo
    aria-hidden="true"
    className={cn(
      "h-12 w-auto transition-colors duration-300",
      variant === 'light' ? 'text-bloom-cream' : 'text-bloom-charcoal',
      className
    )}
    {...props}
  />
);

export default Logo;
